import { axios } from '@/utils/request'

/**
 * 查询问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function baOrganizationPage (parameter) {
  return axios({
    url: '/baOrganization/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 问诊订单管理列表
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function upDataList (parameter) {
  return axios({
    url: '/baOrganization/upLoadJg',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderAdd (parameter) {
  return axios({
    url: '/inquiryorder/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function medicalOrgEdit (parameter) {
  return axios({
    url: '/baOrganization/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderDelete (parameter) {
  return axios({
    url: '/inquiryorder/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderExport (parameter) {
  return axios({
    url: '/inquiryorder/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}



/**
 * 获取问诊订单详情
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function recipeDetial (parameter) {
  return axios({
    url: '/inquiryorder/detail',
    method: 'get',
    params: parameter,
  })
}


/**
 * 获取卫生机构列表
 * @param {} parameter 
 * @returns 
 */
export function getOrgList (parameter) {
  return axios({
    url: '/baOrganization/selectFromData',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取地区
 */
export function getArea (parameter) {
  return axios({
    url: '/baOrganization/selectArea',
    method: 'get',
    params: parameter
  })
}




/**
 * 上传图片
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureUpdate (parameter) {
  return axios({
    url: '/baOrganization/cos/upload',
    method: 'post',
    data: parameter
  })
}

